declare var swal: any;
import { Component, Input, OnInit, ViewChild} from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { SaveCounsellingActivityRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, CounsellingPlanController, CounsellingPlanRequest, CounsellingActivityController, CounsellingActivityRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest, SaveCounsellingPlanRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, IvfSpermStoreByCodeController, IvfSpermStoreByCodeRequest } from '../../../../../.././../src/app/ncs/models/actor/actor';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
//import { NgbActivityMonitoringModal } from './activitymonitoringmodal/activitymonitoring.modal';
import { timeInterval } from 'rxjs/operators';
//import { NgbViewCounsellingPlanModal } from '../counsellingregistry/modal/viewcounsellingplan.modal';
//import { NgbCounsellingRegistryModal } from './modal/counsellingregistry.modal';
@Component({
  selector: 'cryostoragenew',
  templateUrl: './cryostoragenew.component.html',
  styleUrls: ['./cryostoragenew.component.css']
})
export class CryoStorageNewComponent implements OnInit {
  @Input() ActorCode: number;
    @Input() FormattedCode: string;
  @Input() CycleCode: number;
  @Input() GradingModel: string;
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }
  ScheduleDate: NgbDateStruct;
  //public ActorCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public isRequesting: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;
  //@ViewChild('f') IdentitiesForm: NgForm;
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
   SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                   this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    //this.LoadPlan();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentIvfOocyteEmbryoStorageByCodeController: IvfOocyteEmbryoStorageByCodeController[];
    EggList: IvfOocyteEmbryoStorageByCodeController[];
    EmbryoList: IvfOocyteEmbryoStorageByCodeController[];
    CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;

    LoadOqaData() {
        //alert("ScansData")
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfOocyteEmbryoStorageByCodeController();
    }

    GetIvfOocyteEmbryoStorageByCodeController() {
        this.StartRefreshing();

        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = 0;
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.ActorCode;

        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 30;

        //alert(this.FormattedCode);
        this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;
                    this.EggList = this.ApiResData.Result;
                    this.EmbryoList = this.ApiResData.Result;

                    var EggData = this.EggList.filter(
                        function (a) {
                            return a.ItemType == "OOCYTE"
                        });
                    this.EggList = EggData;
                    var EmbryoData = this.EmbryoList.filter(
                        function (b) {

                            return b.ItemType =="EMBRYO"
                        });
                    this.EmbryoList = EmbryoData;
                    //this.FrozenCount = this.CurrentSingleWellCultureByCycleCodeController.length;

                    //this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
                    //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
                    //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

                    //data.forEach((v, i, a) => {
                    //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
                    //});
                    //for (let index = 0; index < data.length; index++){
                    //    //alert(data[index].SingleWellFollicleCoder);

                    //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
                    //}
                    //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
                    //   alert(this.FollicularOocyteInfo.TreatmentCycle);
                    //if (this.FollicularScanEndInfo.ScanDate != null) {
                    //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
                    //  if (SValidFrom.getFullYear() > 1900) {
                    //    console.log('this.UpdateDate >1990');
                    //    this.ScanDate = {

                    //      year: SValidFrom.getFullYear(),
                    //      month: SValidFrom.getMonth() + 1,
                    //      day: SValidFrom.getDate()
                    //    }
                    //  }
                    //}
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentIvfSpermStoreByCodeController: IvfSpermStoreByCodeController[];
    SpermSourceInfo: IvfSpermStoreByCodeController;
    CurrentIvfSpermStoreByCodeRequest: IvfSpermStoreByCodeRequest;
    LoadStoragedata() {
        this.CurrentIvfSpermStoreByCodeRequest = new IvfSpermStoreByCodeRequest();
        this.CurrentIvfSpermStoreByCodeRequest.ConditionalOperator = 20;
        this.CurrentIvfSpermStoreByCodeRequest.TreatmentCycle = 0;
        this.CurrentIvfSpermStoreByCodeRequest.ActorCode = this.ActorCode;
        this.CurrentIvfSpermStoreByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetIvfSpermStoreByCodeController();
    }

    GetIvfSpermStoreByCodeController() {
        this.StartRefreshing();


        this.actorservice.GetIvfSpermStoreByCodeController(this.CurrentIvfSpermStoreByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentIvfSpermStoreByCodeController = this.ApiResData.Result;
                    
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    public printService: PrintService,
    private hcpservice: HCPService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private actorservice: ActorService,
    private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService,
    private loginservice: LoginService) { }
  ngOnInit() {
    
      this.LoadPatients();
      this.LoadOqaData();
      this.LoadStoragedata();
    //this.GetPatientInfoByFormattedCodeController();
  }
  
 
  
  

  

 
  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  Selectedplan: CounsellingPlanController;
  ShowPalnDetails(objCategory: any) {
    var plan: CounsellingPlanController = objCategory;
    if (plan != null) {
      this.Selectedplan = plan;
      this.LoadActivity();
    }
    else {

    }
  }
  CurrentCounsellingActivitiesByTimeController: CounsellingActivitiesByTimeController;
  CurrentCounsellingActivitiesByTimeRequest: CounsellingActivitiesByTimeRequest;
  LoadActivity() {
    this.CurrentCounsellingActivitiesByTimeRequest = new CounsellingActivitiesByTimeRequest();
    this.CurrentCounsellingActivitiesByTimeRequest.PlanCode = this.Selectedplan.CounsellingPlanCode;
    this.CurrentCounsellingActivitiesByTimeRequest.ActorCode = this.ActorCode;
    //this.CurrentCounsellingActivitiesByTimeRequest.Branch = 0;
    this.CurrentCounsellingActivitiesByTimeRequest.ConditionalOperator = 10;
    this.CurrentCounsellingActivitiesByTimeRequest.FromDate = new Date();
    this.CurrentCounsellingActivitiesByTimeRequest.ToDate = new Date();
    //this.CurrentCounsellingActivitiesByTimeRequest.IsToday = true;
    //this.CurrentCounsellingActivitiesByTimeRequest.IsDuration = false;
    this.CurrentCounsellingActivitiesByTimeRequest.SearchText = "";
    this.CurrentCounsellingActivitiesByTimeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCounsellingActivitiesByTimeController();
  }
  GetCounsellingActivitiesByTimeController() {
    this.StartRefreshing();


    this.actorservice.GetCounsellingActivitiesByTimeController(this.CurrentCounsellingActivitiesByTimeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  BackToCryoList() {
    this.router.navigate(['healins/ivffreezing']);
  }
  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }
  gotoviewprofile() {
    //alert(this.gotoviewprofile);
    this.router.navigate(['testnurse/profileview']);
  }
//AddPlan(){
//  const modalRef = this.modalService.open(NgbCounsellingRegistryModal,
//    {
//      centered: true

//    })
//}
  //edit(l: CounsellingActivitiesByTimeController) {

  //  this.CurrentEditCounsellingActivityRequest.ActivityDate = l.ActivityDate;
  //  this.CurrentEditCounsellingActivityRequest.ActivityTime = l.ActivityTime;
  //  this.CurrentEditCounsellingActivityRequest.FollowupMode = l.FollowupMode;
  //  this.CurrentEditCounsellingActivityRequest.Followupstatus = l.FollowupStatus;
  //  this.CurrentEditCounsellingActivityRequest.Remarks = l.Remarks;
  //  this.CurrentEditCounsellingActivityRequest.PlanCode = l.PlanCode;
  //  this.CurrentEditCounsellingActivityRequest.ActualActivityDate = l.ActualActivityDate;
  //  this.CurrentEditCounsellingActivityRequest.ActualActivityTime = l.ActualActivityTime;
  //  this.CurrentEditCounsellingActivityRequest.ActorCode = l.ActorCode;
  //  this.CurrentEditCounsellingActivityRequest.CounsellingActivityCode = l.CounsellingActivityCode;
    
  //  const modalRef = this.modalService.open(NgbActivityMonitoringModal,
  //  {
  //  centered: true
  //    })
  //  modalRef.componentInstance.CurrentEditCounsellingActivityRequest = this.CurrentEditCounsellingActivityRequest;
  //  modalRef.componentInstance.ADate = l.ActivityDate;
  //  modalRef.componentInstance.Time = l.ActivityTime;
  //  //modalRef.componentInstance.ActivityTime = l.ActivityTime;
  //  //modalRef.componentInstance.ADate = l.ActivityDate;
  //  //modalRef.componentInstance.Time = l.ActivityTime;
  //  modalRef.componentInstance.Code = l.PlanCode;
  //  modalRef.componentInstance.Name = l.DisplayName;
  //  modalRef.result.then(x => { this.GetCounsellingActivitiesByTimeController() })
    
  //}

  //Viewplan() {
  //  this.CurrentEditCounsellingPlanRequest.Concerns = this.Selectedplan.Concerns;
  //  this.CurrentEditCounsellingPlanRequest.ActorCode = this.Selectedplan.ActorCode.toString();
  //  this.CurrentEditCounsellingPlanRequest.CounsellingDoctor = this.Selectedplan.CounsellingDoctor;
  //  this.CurrentEditCounsellingPlanRequest.CounsellingPlanCode = this.Selectedplan.CounsellingPlanCode;
  //  this.CurrentEditCounsellingPlanRequest.FinancialStatus = this.Selectedplan.FinancialStatus;
  //  this.CurrentEditCounsellingPlanRequest.PackageCost = this.Selectedplan.PackageCost;
  //  this.CurrentEditCounsellingPlanRequest.PlanStatus = this.Selectedplan.PlanStatus;
  //  this.CurrentEditCounsellingPlanRequest.Potential = this.Selectedplan.Potential;
  //  this.CurrentEditCounsellingPlanRequest.RecommendedPackage = this.Selectedplan.RecommendedPackage;
  //  this.CurrentEditCounsellingPlanRequest.SelectEmi = this.Selectedplan.SelectEmi;
  //  this.CurrentEditCounsellingPlanRequest.TreatmentPlan = this.Selectedplan.TreatmentPlan;
  //  this.CurrentEditCounsellingPlanRequest.VisitCode = this.Selectedplan.VisitCode.toString();
  //  this.CurrentEditCounsellingPlanRequest.EndDate = this.Selectedplan.EndDate;
  //  this.CurrentEditCounsellingPlanRequest.StartDate = this.Selectedplan.StartDate;
  //  const modalRef = this.modalService.open(NgbViewCounsellingPlanModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })
  //  modalRef.componentInstance.CurrentEditCounsellingPlanRequest = this.CurrentEditCounsellingPlanRequest;
  //  modalRef.componentInstance.FormattedCode = this.Selectedplan.FormattedCode;
  //  modalRef.componentInstance.FacilityName = this.Selectedplan.FacilityShortName;
  //  modalRef.result.then(x => { this.GetCounsellingPlanController() })
  //}
  printcryo() {
    this.printService.printDocument("cryostorage",
      {
        ActorCodeData: this.ActorCode, Owner: this.SelectedTreatmentCycle.OwnerName, CycleNo: this.SelectedTreatmentCycle.CycleNo, CycleType: this.SelectedTreatmentCycle.CycleType, Gender: this.SelectedTreatmentCycle.OwnerGender, Age: this.SelectedTreatmentCycle.OwnerAgeYears, PatientID: this.SelectedTreatmentCycle.OwnerFormattedCode, Infertility: this.SelectedTreatmentCycle.InfertilityType, Protocolst: this.SelectedTreatmentCycle.ProtocolStartDate, ProtocolEd: this.SelectedTreatmentCycle.ProtocolEndDate, Protocol: this.SelectedTreatmentCycle.ProtocolName,
        //OCWellNo: this.OqaStoragedetails.WellNo, OCMorphology: this.OqaStoragedetails.Morphology, OCStorage: this.OqaStoragedetails.StorageUnitType, OCDetails: this.OqaStoragedetails.StorageUnitDetails, OCStatus: this.OqaStoragedetails.Status,

      }

    );
  }

}

